import IndexedDb from './IndexedDb'
import Http from './Http'

// Lazily initialize the singular dataSource
let dataSourcePromise

export async function getDataSource() {
  if (!dataSourcePromise) {
    dataSourcePromise = IndexedDb.initialize(Http)
  }
  try {
    return await dataSourcePromise
  } catch (e) {
    console.warn('Cache db init failed. Falling back to direct http', e)
    return Http
  }
}
